import React, {useState} from "react"
import {debounce} from "debounce"
import {Avatar, Button, Input, InputGroup, InputLeftElement, Text} from "@chakra-ui/react"
import {MagnifyingGlassIcon} from "@heroicons/react/24/outline"

import {CatIcon, Table} from "@components/index"
import {labelSetApiCalls} from "@modules/label/service"
import {ILabelSet,PagingType} from "@backend/types"
import {IconNameExt} from "@utils/icons"

type LabelSelectProps = {
    selectedLabelSet: ILabelSet | null,
    onLabelSetChange: ({labelSet}) => void
}

const onSearchDebounce = debounce((val, cb) => {

    if (!val)
        return cb([])

    labelSetApiCalls.apiCalls.listWithPager({searchText: val}).then(cb)
}, 200)

export function LabelSetSelect({selectedLabelSet, onLabelSetChange}: LabelSelectProps) {
    const [labelSetList, setLabelSetList] = useState<PagingType<ILabelSet> | null>(null)

    function onLabelSetAdd(labelSet: ILabelSet) {
        console.log(labelSet)

        labelSetApiCalls.apiCalls.getOne(labelSet._id).then(result => {
            onLabelSetChange({labelSet: result})
        })

        onLabelSetChange({labelSet})
        // const index = selectedLabelSets.findIndex(x => x._id === labelSet._id)
        // if (index === -1) {
        //     labelSetApiCalls.apiCalls.getOne(labelSet._id).then(result => {
        //         onLabelSetChange({labelSets: [...selectedLabelSets, result]})
        //     })
        //
        // }
    }

    return <div>
        <InputGroup className="mb-2">
            <InputLeftElement pointerEvents="none">
                <MagnifyingGlassIcon color="gray.300" className="w-6 h-6"/>
            </InputLeftElement>
            <Input type="search" onChange={e => {
                const val = e.target.value
                onSearchDebounce(val, setLabelSetList)
            }} placeholder="Search by title"/>
        </InputGroup>
        {labelSetList &&
          <Table
            columns={[
                {
                    header: "Label Set",
                    accessorKey: "title",
                    enableColumnFilter: false,
                    enableSorting: false,
                    cell: ({row: {original}}) => <div className="flex items-center">
                        <Avatar
                            bg={original.color}
                            className="mr-4"
                            icon={<CatIcon icon={original.icon as IconNameExt || "blender"} iconSize="lg"/>}/>
                        <div className="flex flex-col justify-start">
                            <Text>{original.title}</Text>
                            <Text fontSize="sm"
                                  color="gray.500">{`${(original.labelIds || []).length} Labels`}</Text>
                        </div>

                    </div>
                },
                {
                    id: "select-button",
                    cell: ({row: {original}}) =>
                        <span>
                                <Button
                                    colorScheme="green"
                                    variant="ghost"
                                    size="sm"
                                    onClick={onLabelSetAdd.bind(null, original)}
                                >Select</Button>
                            </span>
                }
            ]}
            data={(labelSetList || {}).docs || []}
          />}
    </div>
}

// const onSearchDebounce = debounce((val, cb) => {
//
//     if (!val)
//         return cb([])
//
//     labelApiCalls.apiCalls.listWithPager({searchText: val}).then(cb)
// }, 200)
//
// export default function LabelSelect({labels, onLabelsChange}: LabelSelectProps) {
//     const [labelList, setLabels] = useState<PagingType<PickedLabel> | null>(null)
//
//
//     function onLabelAdd(label: PickedLabel) {
//         const index = labels.findIndex(x => x._id === label._id)
//         if (index === -1) {
//             onLabelsChange({labels: [...labels, label]})
//         }
//     }
//
//     function onLabelRemove(labelId: string) {
//         onLabelsChange({labels: labels.filter(x => x._id !== labelId)})
//     }
//
//     return <div className="grid grid-cols-1 gap-x-3 gap-y-4 sm:grid-cols-2">
//         <div className="col-span-1">
//             <InputGroup className="mb-2">
//                 <InputLeftElement pointerEvents="none">
//                     <MagnifyingGlassIcon color="gray.300" className="w-6 h-6"/>
//                 </InputLeftElement>
//                 <Input type="search" onChange={e => {
//                     const val = e.target.value
//                     onSearchDebounce(val, setLabels)
//                 }} placeholder="Search by title or code"/>
//             </InputGroup>
//         </div>
//         <div className="col-span-1">
//             <h2 className="mb-4 text-base font-semibold leading-7 text-gray-900">Selected Labels</h2>
//         </div>
//         <div className="col-span-1">
//             <Table
//                 columns={[
//                     {
//                         header: "Label",
//                         accessorKey: "title",
//                         enableColumnFilter: false,
//                         enableSorting: false,
//                         cell: ({row: {original}, getValue}) => `[${original.code}] ${getValue()}`
//                     },
//                     {
//                         id: "select-button",
//                         cell: ({row: {original}}) => <span>
//                                             <Button
//                                                 colorScheme="green"
//                                                 variant="ghost"
//                                                 size="sm"
//                                                 onClick={onLabelAdd.bind(null, original)}
//                                             >Add</Button>
//                                         </span>
//                     }
//                 ]}
//                 data={(labelList || {}).docs || []}
//             />
//         </div>
//         <div className="col-span-1">
//             <Table
//                 columns={[
//                     {
//                         header: "Label",
//                         accessorKey: "title",
//                         enableColumnFilter: false,
//                         enableSorting: false,
//                         cell: ({row: {original}, getValue}) => `[${original.code}] ${getValue()}`
//                     },
//                     {
//                         header: "",
//                         enableColumnFilter: false,
//                         enableSorting: false,
//                         accessorKey: "_id",
//                         cell: ({getValue}) => <span>
//                                             <Button
//                                                 colorScheme="red"
//                                                 variant="ghost"
//                                                 size="sm"
//                                                 onClick={onLabelRemove.bind(null, getValue())}
//                                             >Remove</Button>
//                                         </span>
//                     }
//                 ]}
//                 data={labels || []}
//             />
//
//         </div>
//     </div>
// }